<template>
	<vs-row id="team-with-loading" class="vs-con-loading__container" vs-w="12">
		<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
			<div class="mb-2" style="border: 1px solid #e4e4e4; border-radius: 10px">
				<floating-buttons
					:titleHeader="$t('BreakTable.Action')"
					:cancelText="$t('MODULE_PERMISSION.Cancel')"
					:saveText="isEditActive ? SubmitButtonTitleEdit : SubmitButtonTitleCreate"
					@save="submitForm"
					@cancel="cancel"
				/>
			</div>
			<form>
				<vx-card :cardBorder="true" :noShadow="true" class="mt-2">
					<div class="vx-row mb-6 mt-6">
						<div class="vx-col w-full">
							<vs-input
								name="name"
								class="w-full"
								:label="$t('Teams.Table.Name')"
								v-model="teamItem.name"
								v-validate="'required'"
							/>
							<span class="text-danger text-sm" v-show="errors.has('name')">
								{{ $t("Teams.Form.ValidMessages.Name") }}
							</span>
						</div>
					</div>
					<div class="vx-row mb-6">
						<div class="vx-col w-full">
							<small>{{ $t("BreakTable.Description") }}</small>
							<vs-textarea
								type="text"
								name="description"
								class="w-full"
								icon-pack="feather"
								icon="icon-message-square"
								icon-no-border
								v-model="teamItem.description"
								v-validate="'required'"
							/>
							<span class="text-danger text-sm" v-show="errors.has('description')">
								{{ $t("Teams.Form.ValidMessages.Description") }}
							</span>
						</div>
					</div>
				</vx-card>
				<vx-card class="mt-2" :cardBorder="true" :noShadow="true" :title="$t('AdditionalFields')">
					<TemplateProperties
						class="mb-4"
						:isUpdate="isEditActive ? true : false"
						:data="template"
						:addPropertie="addPropertie"
						:deletePropertie="deletePropertie"
						:key="templatePropertiesKey"
					/>
				</vx-card>
			</form>
		</vs-col>
	</vs-row>
</template>

<script>
import Api from "@/helpers/api.js";
import DateUtils from "@/helpers/DateUtils.js";
import moduleTeams from "@/store/teams/moduleTeams.js";
import moduleDepot from "@/store/depot/moduleDepot.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import TemplateProperties from "@/components/teams/TemplateProperties.vue";
import FloatingButtons from "@/views/FloatingButtons.vue";

export default {
	name: "TeamsForm",
	props: {
		isEditActive: {
			type: Boolean,
			required: true,
		},
		data: Object,
	},
	components: {
		vSelect,
		flatPickr,
		TemplateProperties,
		FloatingButtons,
	},
	data() {
		return {
			teamItem: {},
			SubmitButtonTitle: "",
			configdateTimePicker: {
				enableTime: true,
				enableSeconds: true,
				noCalendar: true,
				dateFormat: "H:i:S",
			},
			template: [],
			templatePropertiesKey: 10,
		};
	},
	methods: {
		cancel() {
			this.$router.push("/dashboard/teams/list");
		},
		addPropertie(data) {
			let arSet = new Set([...this.template]);
			arSet.add(data);
			this.template = [...arSet];
		},
		deletePropertie(index) {
			this.template.splice(index, 1);
		},
		formatDates(dateString) {
			const newDate = new Date(dateString);
			return DateUtils.toDefaultDateTime(newDate, "HH:MM:SS");
		},
		submitForm() {
			this.$vs.loading();
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.isEditActive) {
						this.updateData();
					} else {
						this.saveData();
					}
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("MissingFieldTitle"),
						text: this.$t("MissingField"),
					});
					this.$vs.loading.close();
				}
			});
		},
		saveData() {
			this.teamItem.template = this.template;
			let params = {...this.teamItem};
			this.$store
				.dispatch("moduleTeams/addTeam", params)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Teams.Messages.TitleConfirmCreate"),
						text: this.$t("Teams.Messages.TextConfirmCreate"),
					});
					this.$vs.loading.close();
					this.$router.push("/dashboard/teams/list");
				})
				.catch((err) => {
					this.$vs.loading.close();
					console.error(err);
					if (err.data.reason === "init_hour greater than end_hour") {
						this.$vs.notify({
							color: "danger",
							title: this.$t("BreakForm.ErrorMessages.Error"),
							text: this.$t("BreakForm.ErrorMessages.InitHourHeigh"),
						});
					} else {
						this.$vs.notify({
							color: "warning",
							title: this.$t("MissingFieldTitle"),
							text: this.$t("MissingField"),
						});
					}
				});
		},
		updateData() {
			let params = {...this.teamItem};
			params.template = this.template;
			this.$store
				.dispatch("moduleTeams/updateItem", params)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Teams.Messages.TitleConfirmUpdate"),
						text: this.$t("Teams.Messages.TextConfirmUpdate"),
					});
					this.$emit("closeSidebar");
					this.$vs.loading.close();
					this.$router.push({name: "TeamsListView"});
				})
				.catch((err) => {
					console.error(err);
					this.$vs.loading.close();
					this.$vs.notify({
						color: "warning",
						title: this.$t("MissingFieldTitle"),
						text: this.$t("MissingField"),
					});
				});
		},
	},
	computed: {
		title() {
			return this.$t("Teams.Teams");
		},
		SubmitButtonTitleCreate() {
			return this.$t("Save");
		},
		SubmitButtonTitleEdit() {
			return this.$t("Crud.Update");
		},
	},
	mounted() {
		if (this.isEditActive) {
			this.$vs.loading({
				container: "#team-with-loading",
				scale: 1,
				type: "sound",
			});
			Api.get("/team/" + this.$route.params.id)
				.then((res) => {
					this.teamItem = res.data;
					this.template = res.data.template;
					this.templatePropertiesKey++;
					this.$vs.loading.close("#team-with-loading > .con-vs-loading");
				})
				.catch((err) => {
					console.error(err);
				});
		}
	},
	created() {
		if (!moduleTeams.isRegistered) {
			this.$store.registerModule("moduleTeams", moduleTeams);
			moduleTeams.isRegistered = true;
		}
		if (!moduleDepot.isRegistered) {
			this.$store.registerModule("moduleDepot", moduleDepot);
			moduleDepot.isRegistered = true;
		}
	},
};
</script>
